import { createSlice } from "@reduxjs/toolkit";

const gaAdminSlice = createSlice({
  name: "GAAdmin",
  initialState: {
    GAAdminDetails: [],
    // translators: [],
    assignedProjects: [],
    assignedFolders: [],
    fileStatus: null,
    validationFileStatus: null,
    targetLanguageId: null,
    assignedFiles: [],
    sentences: [],
    rejectedSentences: [],
    selectedAssignedProjectId: null,
    selectedAssignedFolderId: null,
    selectedAssignedFileId: null,
    selectedFile: [],
    assignedFileDetails: [],
    assignedFileDetailsLoading: false,
    assignedToAllAdmins: false,
    shouldRefreshFileInfo: false,
    shouldRefreshFiles: false,
  },
  reducers: {
    addGAAdminDetails: (state, action) => {
      state.translatorAdminDetails = action.payload;
    },
    //     addTranslators: (state, action) => {
    //       state.translators = action.payload;
    //     },
    addAssignedProjects: (state, action) => {
      state.assignedProjects = action.payload;
    },
    addAssignedFolders: (state, action) => {
      state.assignedFolders = {
        ...state.assignedFolders,
        [state.selectedAssignedProjectId]: action.payload,
      };
    },
    addAssignedFiles: (state, action) => {
      state.assignedFiles = {
        ...state.assignedFiles,
        [state.selectedAssignedFolderId]: action.payload,
      };
    },
    addSentences: (state, action) => {
      state.sentences = action.payload;
    },
    addRejectedSentences: (state, action) => {
      state.rejectedSentences = action.payload;
    },
    setSelectedAssignedProjectId: (state, action) => {
      state.selectedAssignedProjectId = action.payload;
    },
    setSelectedAssignedFolderId: (state, action) => {
      state.selectedAssignedFolderId = action.payload;
    },
    setSelectedAssignedFileId: (state, action) => {
      state.selectedAssignedFileId = action.payload;
    },
    setSelectedFile: (state, action) => {
      state.selectedFile = action.payload;
    },
    setAssignToAllAdmins: (state, payload) => {
      state.assignedToAllAdmins = true;
    },
    setShouldRefreshFileInfo: (state, action) => {
      state.shouldRefreshFileInfo = action.payload;
    },
    resetShouldRefreshFileInfo: (state) => {
      state.shouldRefreshFileInfo = false;
    },
    setShouldRefreshFiles: (state, action) => {
      state.shouldRefreshFiles = action.payload;
    },
    resetShouldRefreshFiles: (state) => {
      state.shouldRefreshFiles = false;
    },
    setFileStatus: (state, action) => {
      state.fileStatus = action.payload;
    },
    setValidationFileStatus: (state, action) => {
      state.validationFileStatus = action.payload;
    },
    setTargetLanguageId: (state, action) => {
      state.targetLanguageId = action.payload;
    },
  },
});

export const {
  addAssignedFiles,
  addAssignedFolders,
  addAssignedProjects,
  addGAAdminDetails,
  addTranslators,
  setSelectedAssignedFileId,
  setSelectedAssignedFolderId,
  setSelectedAssignedProjectId,
  setSelectedFile,
  addSentences,
  addRejectedSentences,
  setAssignToAllAdmins,
  setShouldRefreshFileInfo,
  resetShouldRefreshFileInfo,
  setShouldRefreshFiles,
  resetShouldRefreshFiles,
  setFileStatus,
  setValidationFileStatus,
  setTargetLanguageId
} = gaAdminSlice.actions;

export default gaAdminSlice.reducer;
